module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./InterWalletView.js"));
	}, "BonusWalletView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=BonusWalletView!./src/pages/Shop/Member/Wallet/InterWallet/InterWalletView.js
// module id = 1066
// module chunks = 431